import type { CollectionModelFieldText } from '@ikegps/core-shared';
import { Input, MIN_NUMBER_ROWS } from '../../../components/input/input';
import { InputState } from '../../../components/input/input.state';
import { CSS } from '../../../components/input/input.style';
import { m, type MithrilVNode } from '../../../mithril';
import type { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const MAX_STRING_LENGTH = 40;

function getRowsNumber(value: string) {
	let rows = MIN_NUMBER_ROWS;

	const lines = value.split('\n');
	if (lines.length > MIN_NUMBER_ROWS) {
		rows = 0;
		lines.forEach((line) => (rows += getRowsNumber(line)));
	} else if (value.length > MAX_STRING_LENGTH) {
		rows = Math.ceil(value.length / MAX_STRING_LENGTH);
	}

	return rows;
}

export const TextFieldView: CollectionFieldView<CollectionModelFieldText> = {
	viewInline(field: CollectionModelFieldText): MithrilVNode | string {
		const value = field.value;
		const rows = getRowsNumber(value);

		if (rows === MIN_NUMBER_ROWS) {
			return field.displayValue;
		} else {
			const classList = [CSS.container, CSS.MDL.container, CSS.isCompact];

			const className = classList.join(' ');

			const attrs = {
				className: CSS.input + ' ' + CSS.MDL.input,
				rows,
				value,
				title: value,
				disabled: true,
				style: { resize: 'none', overflow: 'hidden', outline: 'none' },
			} as any;

			const children: MithrilVNode[] = [m('textarea', attrs)];

			return m('div', { className }, children);
		}
	},

	canGeocoding(field: CollectionModelFieldText): boolean {
		const metadata = field.collection.schema.metadata;
		if (metadata.options.address_lookup) {
			if (field.schema.id === metadata.options.address_lookup.address.field) {
				return true;
			}
		}

		return false;
	},

	viewDetail(field: CollectionModelFieldText): MithrilVNode {
		return null;
	},

	viewEdit(field: CollectionModelFieldText, ctrl: CollectionEditCtrl): MithrilVNode {
		let inputState = ctrl.changeState.getState(field.id);
		if (inputState == null) {
			inputState = new InputState(field.schema.displayName);
			inputState.onValue(() => field.Mutator.manual(inputState.value));
			ctrl.changeState.addState(field.id, inputState);
		}

		if (!inputState.focused && inputState.value !== field.value) {
			inputState.setValue(field.value);
		}

		const value = inputState.value;
		const rows = getRowsNumber(value);

		return Input.view(inputState, { rows });
	},

	hasClear(field: CollectionModelFieldText) {
		return false;
	},
};
